import { TripRole } from '../firebase/firebase.types';

/** Returns true when the whole string is a single email address (case-insensitive). */
export const validateEmail = (email: string): boolean =>
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
    email
  );

export const copyTextToClipboard = async (text: string): Promise<void> => {
  if ('clipboard' in navigator) {
    return navigator.clipboard.writeText(text);
  }
  return Promise.reject(new Error('Browser clipboard not supported'));
};

export const roleDescriptions: Partial<Record<TripRole, { title: string; description: string }>> = {
  [TripRole.EDITOR]: {
    title: 'Editor',
    description: 'Edit, suggest, comment, and share with others',
  },
  [TripRole.VIEWER]: {
    title: 'Viewer',
    description: 'View only',
  },
};

export const doesUserEmailAlreadyHaveAccess = (
  userRoles: Array<{ email: string }>,
  email: string
): boolean =>
  // Emails are case-insensitive; the invite lookup lowercases what the user typed.
  userRoles.some((userAndRole) => userAndRole.email.toLowerCase() === email.trim().toLowerCase());

export const getRoleForUser = (
  userRoles: Array<{ userId: string; role: TripRole }>,
  userId: string
): TripRole | undefined => {
  const userRole = userRoles.find((userAndRole) => userAndRole.userId === userId);
  return userRole?.role;
};
